import { render, staticRenderFns } from "./SwiperGallery.vue?vue&type=template&id=452e20a1&scoped=true&"
import script from "./SwiperGallery.vue?vue&type=script&lang=js&"
export * from "./SwiperGallery.vue?vue&type=script&lang=js&"
import style0 from "./SwiperGallery.vue?vue&type=style&index=0&id=452e20a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e20a1",
  null
  
)

export default component.exports